"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdatePaymentStatusDto = exports.StripeAccountStatusDto = exports.PaymentSettingsDto = exports.PaymentDto = exports.GetPaymentMethodsDto = exports.SendPaymentRequestDto = exports.RevertMetaDto = exports.RemoveResourceDto = exports.NotePrivacyDto = exports.UpdateNoteContentDto = exports.CreateNoteDto = exports.AddToInvoiceDto = exports.SendReceiptDataDto = exports.PaymentDataDto = exports.PaymentIntentDto = exports.StationsDto = exports.FindPayments = exports.ByPaymentFilter = exports.PaymentViaInvoiceHashDto = exports.GetPaymentsQueryDto = exports.GetInvoicesQueryDto = exports.InvoiceIdAndUserIdDto = exports.ByInvoiceAndCustomerDto = exports.ByInvoiceDto = exports.InvoiceIdDto = exports.GetPaymentByCustomerDeprecatedDto = exports.GetPaymentByUserDto = exports.ByPaymentDto = exports.GetPaymentDto = exports.ByPaymentAndCustomerDto = exports.PaymentIdDto = exports.CustomerIdDto = void 0;
const general_dto_1 = require("../../dto/general.dto");
const userPaymentMethod_dto_1 = require("../../dto/userPaymentMethod.dto");
const organization_dto_1 = require("../../organization/dto/organization.dto");
class CustomerIdDto {
}
exports.CustomerIdDto = CustomerIdDto;
class PaymentIdDto {
}
exports.PaymentIdDto = PaymentIdDto;
class ByPaymentAndCustomerDto extends PaymentIdDto {
}
exports.ByPaymentAndCustomerDto = ByPaymentAndCustomerDto;
class GetPaymentDto extends PaymentIdDto {
}
exports.GetPaymentDto = GetPaymentDto;
class ByPaymentDto extends organization_dto_1.ByOrganizationIdDto {
}
exports.ByPaymentDto = ByPaymentDto;
class GetPaymentByUserDto extends ByPaymentDto {
}
exports.GetPaymentByUserDto = GetPaymentByUserDto;
class GetPaymentByCustomerDeprecatedDto extends ByPaymentDto {
}
exports.GetPaymentByCustomerDeprecatedDto = GetPaymentByCustomerDeprecatedDto;
class InvoiceIdDto {
}
exports.InvoiceIdDto = InvoiceIdDto;
class ByInvoiceDto extends organization_dto_1.ByOrganizationIdDto {
}
exports.ByInvoiceDto = ByInvoiceDto;
class ByInvoiceAndCustomerDto extends ByInvoiceDto {
}
exports.ByInvoiceAndCustomerDto = ByInvoiceAndCustomerDto;
class InvoiceIdAndUserIdDto extends InvoiceIdDto {
}
exports.InvoiceIdAndUserIdDto = InvoiceIdAndUserIdDto;
class GetInvoicesQueryDto {
}
exports.GetInvoicesQueryDto = GetInvoicesQueryDto;
class GetPaymentsQueryDto {
}
exports.GetPaymentsQueryDto = GetPaymentsQueryDto;
class PaymentViaInvoiceHashDto {
}
exports.PaymentViaInvoiceHashDto = PaymentViaInvoiceHashDto;
class ByPaymentFilter extends general_dto_1.PaginationQuery {
}
exports.ByPaymentFilter = ByPaymentFilter;
class FindPayments extends ByPaymentFilter {
}
exports.FindPayments = FindPayments;
class StationsDto {
}
exports.StationsDto = StationsDto;
class PaymentIntentDto {
}
exports.PaymentIntentDto = PaymentIntentDto;
class PaymentDataDto {
}
exports.PaymentDataDto = PaymentDataDto;
class SendReceiptDataDto {
}
exports.SendReceiptDataDto = SendReceiptDataDto;
class AddToInvoiceDto extends InvoiceIdDto {
}
exports.AddToInvoiceDto = AddToInvoiceDto;
class CreateNoteDto {
}
exports.CreateNoteDto = CreateNoteDto;
class UpdateNoteContentDto extends CreateNoteDto {
}
exports.UpdateNoteContentDto = UpdateNoteContentDto;
class NotePrivacyDto {
}
exports.NotePrivacyDto = NotePrivacyDto;
class RemoveResourceDto {
}
exports.RemoveResourceDto = RemoveResourceDto;
class RevertMetaDto {
}
exports.RevertMetaDto = RevertMetaDto;
class SendPaymentRequestDto extends InvoiceIdDto {
}
exports.SendPaymentRequestDto = SendPaymentRequestDto;
class GetPaymentMethodsDto {
}
exports.GetPaymentMethodsDto = GetPaymentMethodsDto;
// TODO: change it to real dto with profile
class PaymentDto extends userPaymentMethod_dto_1.BasePaymentMethodFieldsDto {
}
exports.PaymentDto = PaymentDto;
class PaymentSettingsDto {
}
exports.PaymentSettingsDto = PaymentSettingsDto;
class StripeAccountStatusDto {
}
exports.StripeAccountStatusDto = StripeAccountStatusDto;
class UpdatePaymentStatusDto {
}
exports.UpdatePaymentStatusDto = UpdatePaymentStatusDto;
//# sourceMappingURL=payment.dto.js.map